import React, { useContext } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import ListGameComponent from "../components/gamesComponents/ListGameComponent";
import IndexComponent from "../components/IndexComponent";
import FormTableMovies from "../components/moviesComponents/FormTableMovies";
import ListMovieComponent from "../components/moviesComponents/ListMovieComponent";
import TableMoviesComponent from "../components/moviesComponents/TableMoviesComponents";
import NavComponent from "../components/NavComponent";
import LoginComponent from "../components/userComponents/LoginComponents";
import RegisterComponent from "../components/userComponents/RegisterComponent";
import { UserContext } from "../components/userComponents/UserContext";
import TableGamesComponent from "../components/gamesComponents/TableGamesComponent";
import FormTableGames from "../components/gamesComponents/FormTableGames";
import BottomComponent from "../components/BottomComponent";

import SingleComponent from "../components/userComponents/SingleComponent";
import SingleMovieComponent from "../components/userComponents/SingleMovieComponent";
import SingleEditMovieComponent from "../components/userComponents/SingleEditMovieComponent";
import ChangePasswordComponent from "../components/userComponents/ChangePasswordComponent";
import SingleEditGamesComponent from "../components/userComponents/SingleEditGamesComponent";

const Routers = (props) => {
  const [user] = useContext(UserContext);
  const PrivateRoute = ({ user, ...props }) => {
    return user ? <Route {...props} /> : <Redirect to="/login" />;
  };
  const LoginRoute = ({ user, ...props }) => {
    return user ? <Redirect to="/login" /> : <Route {...props} />;
  };
  return (
    <BrowserRouter>
      <NavComponent />
      <Container>
        <Switch>
          <Route path="/" exact>
            <IndexComponent />
          </Route>
          <Route path="/movies" exact>
            <ListMovieComponent />
          </Route>
          <Route path="/games" exact>
            <ListGameComponent />
          </Route>
          <Route path="/login" exact>
            <LoginComponent />
          </Route>
          <Route path="/changeP" exact>
            <ChangePasswordComponent />
          </Route>
          <LoginRoute path="/register" exact>
            <RegisterComponent />
          </LoginRoute>
          <PrivateRoute path="/fgames" user={user} exact>
            <TableGamesComponent />
          </PrivateRoute>
          <PrivateRoute path="/fmovies" user={user} exact>
            <TableMoviesComponent />
          </PrivateRoute>
          <Route path="/game/:id" user={user} exact>
            <SingleComponent />
          </Route>
          <Route path="/movie/:id" user={user} exact>
            <SingleMovieComponent />
          </Route>
          <Route path="/fmovies/input" exact>
            <FormTableMovies />
          </Route>
          <Route path="/fgames/input" exact>
            <FormTableGames />
          </Route>
          <Route
            path={`/Edit/Movie/:id`}
            exact
            children={<SingleEditMovieComponent />}
          />
          <Route
            path={`/Edit/Games/:id`}
            exact
            children={<SingleEditGamesComponent />}
          />
        </Switch>
        <BottomComponent />
      </Container>
    </BrowserRouter>
  );
};

export default Routers;
